import angular from 'angular';
import quotationsComponent from './quotations.component';
import quotationsService from './quotations.service';
import quotationsConfig from './quotations.config';

let quotationsModule = angular.module('app.quotations',[])
  .component('quotations', quotationsComponent)
  .service('QuotationsService', quotationsService)
  .config(quotationsConfig);
export default quotationsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/quotations/quotations.js
 **/